import { render, staticRenderFns } from "./ComponentIndexTravel.vue?vue&type=template&id=77fb4224"
import script from "./ComponentIndexTravel.vue?vue&type=script&lang=js"
export * from "./ComponentIndexTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports